// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"98":"View","162":"react-easy-state","768":"App"}[chunkId] || chunkId) + ".js";
};